import React from 'react';
import toast from 'react-hot-toast';
import useApi from '../../hooks/useApi';
import { BillingCycleRes } from '../rtm_plan/index.type';

export interface IState{
key:string,
value:string
}

const useAllFrequency = () => {
    const [frequency, setFrequecy] = React.useState<IState[]>([]);

    
    const { loading:frequencyLoading, makeApiCall } = useApi({
      url: `/rtm/billing-cycle/frequency`,
      method: 'GET',
    });
  
    const getFrequency = async () => {
      const { response, error } = await makeApiCall<undefined, BillingCycleRes>();
      
      if (response?.status === 'success') {
        console.log(response.data)
        setFrequecy(response?.data);
        
      }
  
      if (error) toast.error('Something went wrong while fetching frequency. Please try again later');
      return [];
    };
  
    return {
      frequencyLoading,
      getFrequency,
    frequency,
    };
  };
  
export default useAllFrequency;